import React, {type ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {PaymentsCart} from '@chekin/core';
import {StatusModalStates} from '@chekin/shared';
import {
  PaymentForm as SharedPaymentForm,
  type PaymentFormState,
} from '@chekin/shared/payments';
import {useRegisterNavigationGuard} from 'context/navigationGuard';

type Props = {
  isLoading: boolean;
  onSuccess: () => void;
  onReceiptsReady: () => void;
  paymentsCart?: PaymentsCart;
  successActions?: ReactNode;
};

function PaymentForm(props: Props) {
  const {t} = useTranslation();
  const [formState, setFormState] = React.useState<PaymentFormState>();

  useRegisterNavigationGuard({
    when:
      Boolean(formState?.isDirty) && formState?.processState === StatusModalStates.IDLE,
    title: t('leave_without_paying_title'),
    description: t('leave_without_paying_description'),
    confirmLabel: t('leave_anyway'),
    cancelLabel: t('stay_on_this_page'),
  });

  return <SharedPaymentForm {...props} onStateChange={setFormState} />;
}

export {PaymentForm};
